import { IRootState } from '../../app/store';

export const selectOrganizations = (state: IRootState) =>
    state.organizations?.organizations || [];
